// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cS","reportCardBox":"cS","report-img-wrap":"cT","reportImgWrap":"cT","report-title":"cU","reportTitle":"cU","report-date":"cV","reportDate":"cV"};